export default __webpack_public_path__ + "715d29b128f435397e99677365ba683e.png";